<template>
    <BreadCrumb PageTitle="Détails d'un chef quartier" />
    <Viewchq />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import Viewchq from "@/components/Assignations/Viewchq.vue";

export default defineComponent({
    name: "ViewchqPage",
    components: {
        BreadCrumb,
        Viewchq,
    },
});
</script>